
export const Features = (props) => {
  const numbers = ['01', '02', '03', '04'];

  return (
    <section id='features' style={{ padding: '100px 0', background: '#fff' }}>
      <div className='container'>
        <div className='features-layout'>

          {/* ── LEFT COLUMN ── */}
          <div className='features-left'>

            <p style={{
              color: '#5ca9fb',
              fontWeight: '700',
              fontSize: '12px',
              letterSpacing: '3px',
              textTransform: 'uppercase',
              margin: '0 0 16px',
            }}>
              — Why Choose Us
            </p>

            <h2 style={{
              fontFamily: 'Raleway, sans-serif',
              fontSize: 'clamp(32px, 3.5vw, 50px)',
              fontWeight: '800',
              color: '#0f0f1a',
              lineHeight: '1.1',
              margin: '0 0 24px',
            }}>
              The ACTECH<br />
              <span style={{ color: '#5ca9fb' }}>Difference</span>
            </h2>

            <p style={{
              color: '#777',
              fontSize: '16px',
              lineHeight: '1.8',
              margin: '0 0 40px',
              maxWidth: '360px',
            }}>
              We deliver commercial HVAC solutions with the structure, reliability, and technical depth that corporate clients and facility managers require.
            </p>

            {/* Stats */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '40px' }}>
              {[
                { value: '20+', label: 'Years in Operation' },
                { value: '4hrs', label: 'Emergency Response' },
                { value: '40%', label: 'Energy Savings' },
                { value: '99%+', label: 'System Uptime' },
              ].map((s, i) => (
                <div key={i} style={{
                  padding: '18px 20px',
                  background: '#f8faff',
                  borderRadius: '12px',
                  borderLeft: '3px solid #5ca9fb',
                }}>
                  <div style={{
                    fontFamily: 'Raleway, sans-serif',
                    fontSize: '22px',
                    fontWeight: '800',
                    color: '#5ca9fb',
                    lineHeight: 1,
                    marginBottom: '4px',
                  }}>{s.value}</div>
                  <div style={{ color: '#999', fontSize: '12px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{s.label}</div>
                </div>
              ))}
            </div>

            {/* CTAs */}
            <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
              <a
                href='https://wa.me/2348103218560?text=Hello%20Ac-Tech!%20I%E2%80%99d%20like%20to%20get%20a%20quote%20for%20AC%20service.%20Can%20you%20help%3F'
                target='_blank'
                rel='noopener noreferrer'
                className='feat-btn'
                style={{
                  display: 'inline-flex', alignItems: 'center', gap: '8px',
                  background: 'linear-gradient(to right, #25D366, #128C7E)',
                  color: '#fff', padding: '13px 26px', borderRadius: '50px',
                  textDecoration: 'none', fontWeight: '700', fontSize: '13px',
                  textTransform: 'uppercase', letterSpacing: '0.5px',
                  boxShadow: '0 8px 24px rgba(37,211,102,0.35)',
                }}
              >
                <i className='fa fa-whatsapp'></i> Chat on WhatsApp
              </a>
              <a href='tel:08103218560' className='feat-btn' style={{
                display: 'inline-flex', alignItems: 'center', gap: '8px',
                color: '#444', padding: '13px 26px', borderRadius: '50px',
                textDecoration: 'none', fontWeight: '700', fontSize: '13px',
                textTransform: 'uppercase', letterSpacing: '0.5px',
                border: '2px solid #e8e8e8',
              }}>
                <i className='fa fa-phone' style={{ color: '#5ca9fb' }}></i> Call Now
              </a>
            </div>
          </div>

          {/* ── RIGHT COLUMN: 2×2 CARDS ── */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '18px' }}>
            {props.data
              ? props.data.map((d, i) => {
                  const isDark = i % 2 === 1;
                  return (
                    <div
                      key={`${d.title}-${i}`}
                      className='feature-card'
                      style={{
                        background: isDark ? '#0f0f1a' : '#f8faff',
                        borderRadius: '18px',
                        padding: '30px 26px',
                        border: isDark ? 'none' : '1px solid #eef0ff',
                        transition: 'transform 0.25s, box-shadow 0.25s',
                        position: 'relative',
                        overflow: 'hidden',
                      }}
                      onMouseEnter={e => {
                        e.currentTarget.style.transform = 'translateY(-5px)';
                        e.currentTarget.style.boxShadow = isDark
                          ? '0 24px 48px rgba(0,0,0,0.35)'
                          : '0 16px 40px rgba(92,169,251,0.15)';
                      }}
                      onMouseLeave={e => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = 'none';
                      }}
                    >
                      {/* Ghost number */}
                      <span style={{
                        position: 'absolute', top: '14px', right: '18px',
                        fontFamily: 'Raleway, sans-serif',
                        fontSize: '52px', fontWeight: '900', lineHeight: 1,
                        color: isDark ? 'rgba(255,255,255,0.05)' : 'rgba(92,169,251,0.1)',
                        userSelect: 'none', pointerEvents: 'none',
                      }}>
                        {numbers[i]}
                      </span>

                      {/* Icon box */}
                      <div className='feat-icon' style={{
                        width: '46px', height: '46px',
                        borderRadius: '12px',
                        background: isDark ? 'rgba(92,169,251,0.12)' : '#fff',
                        border: isDark ? '1px solid rgba(92,169,251,0.25)' : '1px solid #dde5ff',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        marginBottom: '18px',
                      }}>
                        <i className={d.icon} style={{ fontSize: '18px', color: '#5ca9fb' }}></i>
                      </div>

                      <h3 style={{
                        fontFamily: 'Raleway, sans-serif',
                        fontSize: '16px', fontWeight: '700',
                        color: isDark ? '#fff' : '#0f0f1a',
                        margin: '0 0 10px',
                      }}>
                        {d.title}
                      </h3>

                      <p style={{
                        color: isDark ? 'rgba(255,255,255,0.5)' : '#888',
                        fontSize: '14px', lineHeight: '1.7', margin: 0,
                      }}>
                        {d.text}
                      </p>
                    </div>
                  );
                })
              : 'Loading...'}
          </div>

        </div>
      </div>

      <style>{`
        .features-layout {
          display: grid;
          grid-template-columns: 1fr 1.3fr;
          gap: 80px;
          align-items: center;
        }

        /* Override global #features i.fa styles for buttons and icon boxes */
        #features .feat-btn i.fa,
        #features .feat-icon i.fa {
          font-size: 18px !important;
          width: auto !important;
          height: auto !important;
          padding: 0 !important;
          border-radius: 0 !important;
          background: none !important;
          box-shadow: none !important;
          margin-bottom: 0 !important;
          color: inherit !important;
          display: inline !important;
          transition: none !important;
        }

        @media (max-width: 900px) {
          .features-layout {
            grid-template-columns: 1fr !important;
            gap: 48px !important;
          }
        }
      `}</style>
    </section>
  );
};
